/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */




import BaseObject from "@shared/BaseObject";

export default class CurrencyItem extends BaseObject{

	currencyName: string = null
	currencyCode: string = null
	currencySign: string = null


	constructor(currencyCode: string = "", currencySign: string = "", currencyName: string = "") {
		super();
		this.currencyCode = currencyCode;
		this.currencySign = currencySign;
		this.currencyName = currencyName
	}

	toString(){
		return this.currencySign || this.currencyName
	}
	formatted(amount = 0, fractionalDigits = 2){
		amount = Number(amount)
		amount = Math.ceil(amount * 100) / 100
		amount = amount.toFixed(fractionalDigits)
		if(this.currencySign){
			return this.currencySign + amount + " " + this.currencyCode
		}
		return "" + amount + " " + this.currencyName
	}

	static currencyByCode(code){
		// console.log("CurrencyItem.currencyList = ", CurrencyItem.currencyList, " code = ", code)
		for(let currency of CurrencyItem.currencyList){
			if(currency.currencyCode === code){
				return currency
			}
		}
		return CurrencyItem.USD
	}

	static USD = new CurrencyItem("USD", "$", "US Dollar")
	static EUR = new CurrencyItem("EUR", "€", "Euro")
	static GBP = new CurrencyItem("GBP", "£", "British Pound Sterling")
	static AUD = new CurrencyItem("AUD", "$", "Australian Dollar")
	static CAD = new CurrencyItem("CAD", "$", "Canadian Dollar")
	static JPY = new CurrencyItem("JPY", "¥", "Japanese Yen")
	static CNY = new CurrencyItem("CNY", "¥", "Chinese Yuan")
	static RUB = new CurrencyItem("RUB", "₽", "Russian Ruble")
	static INR = new CurrencyItem("INR", "₹", "Indian Rupee")
	static BRL = new CurrencyItem("BRL", "R$", "Brazilian Real")
	static PHP = new CurrencyItem("PHP", "₱", "Philippine Peso")


	static currencyList = [
		CurrencyItem.USD,
		CurrencyItem.EUR,
		CurrencyItem.GBP,
		CurrencyItem.AUD,
		CurrencyItem.CAD,
		CurrencyItem.JPY,
		CurrencyItem.CNY,
		CurrencyItem.RUB,
		CurrencyItem.INR,
		CurrencyItem.BRL,
		CurrencyItem.PHP,
	]


}
